function SmartRoom() {
  return (
    <div className="smartRoom">
      <div className="container">
        <h5 className="title">Phòng nghỉ thông minh</h5>
        <div className="imgAb">
          <img
            className="img-fluid "
            src="/images/kich-thuoc-la-chuyen-nho.png"
            alt=""
          />
        </div>
        <div className="row">
          <div className="col-lg-4 col-12 col-md-4 smartRoomItem">
            <div className="itemBox">
              <img
                className="img-fluid"
                src="/images/room-image-1.png"
                alt=""
              />
            </div>
            <div className="itemContent">
              <p>Tầm nhìn toàn cảnh qua cửa sổ bao trọn không gian</p>
            </div>
          </div>
          <div className="col-lg-4 col-12 col-md-4 smartRoomItem">
            <div className="itemBox">
              <img
                className="img-fluid"
                src="/images/room-image-2.png"
                alt=""
              />
            </div>
            <div className="itemContent">
              <p>Chiếc giường XL ru những giấc mơ ngon dài</p>
            </div>
          </div>
          <div className="col-lg-4 col-12 col-md-4 smartRoomItem">
            <div className="itemBox">
              <img
                className="img-fluid"
                src="/images/room-image-3.png"
                alt=""
              />
            </div>
            <div className="itemContent">
              <p>
                Tiện lợi bất ngờ với sự kết hợp giữa bàn làm việc, tủ quần áo và
                chậu rửa
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SmartRoom;
